export function getCurrentUrl() {
  let fullPath = window.location.href;
  let pathArr = fullPath.split("/");
  let tourPathArr = [
    pathArr[0],
    pathArr[1],
    pathArr[2]
  ];
  const url = tourPathArr.join("/");
  return url;
}

export function isUndefined(data) {
  return typeof data === 'undefined';
}

/**
 * 只能在客戶端用
 * target:  "/mobile/member/mine"
 * */
export function redirectToTarget(target, store) {
  const currenUri = getCurrentUrl();

  //fangfa1:
  // window.open(currenUri + target, "_self")
  // store.dispatch("deleteUserInfo").then(() => {
  //   window.location.href = currenUri + target;
  // })
  window.location.href = currenUri + target;

  //fangfa2:
  // let a = document.createElement("a");
  // document.body.appendChild(a);
  // a.style = "display: none";
  // a.target = "_self";
  // a.id = "newPage";
  // a.text = "newPage";
  // a.href = currenUri + target;
  // document.getElementById("newPage").click();
  // document.body.removeChild(a);
  // window.open(currenUri + target, "_self");
  // console.log("=====強制刷新頁面")
}


export function isMobile() {
  if (typeof window === 'undefined') return false;
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}

export function deepClone(obj) {
  let newObj = JSON.parse(
    JSON.stringify(obj)
  );
  return newObj;
}

export function rotateToAngle360(rotate) {
  if (rotate >= 0) {
    return rotate;
  } else {
    360 - rotate;
  }
}

export function angle360ToRotate(angle) {
  if (angle >= 180) {
    return angle - 360;
  } else {
    return angle;
  }
}

export function angleToAngle360(angle) {
  return angle % 360;
}

export function angleToRotate(angle) {
  return angle360ToRotate(angleToAngle360(angle));
}

/**
 * 獲取時間格式 YY-mm-dd
 */
export function getDateStr(AddDayCount = 0) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount)
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 獲取當前月份的日期
  if (parseInt(m) < 10) {
    m = '0' + m
  }
  var d = dd.getDate()
  if (parseInt(d) < 10) {
    d = '0' + d
  }
  return y + '-' + m + '-' + d
}
/**
 * 獲取本周第一天日期格式 YY-mm-dd
 */
export function getThisWeekMonDayStr() {
  var dd = new Date()
  dd.setDate(dd.getDate() - dd.getDay() + 1)
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 獲取當前月份的日期
  if (parseInt(m) < 10) {
    m = '0' + m
  }
  var d = dd.getDate()
  if (parseInt(d) < 10) {
    d = '0' + d
  }
  return y + '-' + m + '-' + d
}
/**
 * 獲取本月第一天日期格式 YY-mm-dd
 */
export function getThisMonthFirstDayStr() {
  var dd = new Date()
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 獲取當前月份的日期
  if (parseInt(m) < 10) {
    m = '0' + m
  }
  return y + '-' + m + '-' + '01'
}

/**
 * 獲取本年第一天日期格式 YY-mm-dd
 */
export function getThisYearFirstDayStr() {
  var dd = new Date()
  var y = dd.getFullYear()
  return y + '-' + '01' + '-' + '01'
}

export function getImageWH(url) {
  const img = new Image();
  img.src = url;
  new Promise((resolve, reject) => {
    img.onload = () => {
      resolve({ width: img.width, height: img.height })
    };
    img.οnerrοr = function () {
      reject({ error: "圖片加載失敗" });
    };
  })
}
/**
 * 計算目標元素的寬高
 * condig:{
 * ratio: ratio, //寬高比
 * initWidth: initWidth,
 * initHeight: initHeight,
 * isFullScreen: isFullScreen, //是否是放大
 * isEdit: isEdit //是不是編輯部分
 * }
 * */
export function handleImageSize(config) {
  if (!config) return;
  if (config.isFullScreen) {
    return fullscreenImage(config);
  } else {
    return normalSize(config)
  }
}

function normalSize(config) {
  let cWidth = 0, cHeight = 0, tempW = 0, tempH = 0;
  const ratio = config.ratio;
  const isEdit = config.isEdit;
  const initWidth = config.initWidth;
  const initHeight = config.initHeight;
  // 因為pc和移動端的佈局差異，傳element過來計算展示空間不合適，所以直接統計寫死
  const pcHGapSpace = 350;
  const pcVGapSpace = 200;
  // const mbHGapSpace = 0;
  // const mbVGapSpace = 180;
  cWidth = document.documentElement.clientWidth || document.body.clientWidth;
  cHeight = document.documentElement.clientHeight || document.body.clientHeight;

  if (ratio === 0) {
    tempH = initHeight;
    tempW = initWidth;
  } else if (ratio > 1) {
    tempW = initWidth;
    tempH = tempW / ratio;
    if (isEdit && !isMobile()) {//編輯部分，pc端單獨處理
      tempW = (cWidth - pcHGapSpace) * 0.5;
      tempH = tempW / ratio;
    }
    if (!isEdit && isMobile()) {
      tempW = cWidth * 0.4;
      tempH = tempW / ratio;
    }
  } else if (ratio < 1) {
    tempH = initHeight;
    tempW = tempH * ratio
    if (isEdit && !isMobile()) {//編輯部分，pc端單獨處理
      tempH = (cHeight - pcVGapSpace) * 0.8;
      tempW = tempH * ratio;
    }
    if (!isEdit && isMobile()) {
      tempH = cWidth * 0.4;
      tempW = tempH * ratio
    }
  } else if (ratio === 1) {
    tempH = tempW = initWidth > initHeight ? initWidth : initHeight;
    if (!isEdit && isMobile()) {
      tempW = tempH = cWidth * 0.4;
    }
  }
  return { height: tempH + "px", width: tempW + "px" }
}

function fullscreenImage(config) {
  const ratio = config.ratio;
  let cWidth = 0, cHeight = 0, tempW = 0, tempH = 0;
  const gap = 100;
  cWidth = document.documentElement.clientWidth || document.body.clientWidth;
  cHeight = document.documentElement.clientHeight || document.body.clientHeight;
  if (ratio === 0) {
    tempH = cHeight - gap;
    tempW = cWidth - gap;
  } else if (ratio > 1) {
    tempW = isMobile() ? cWidth : cWidth * 0.8;
    tempH = tempW / ratio;
    if (tempH > cHeight - gap) {
      tempH = cHeight - gap;
      tempW = tempH * ratio;
    }
  } else if (ratio < 1) {
    tempH = cHeight - gap
    tempW = tempH * ratio
    if (tempW > cWidth) {
      tempW = cWidth;
      tempH = tempW / ratio;
    }
  } else if (ratio === 1) {
    tempH = tempW = isMobile() ? cWidth : (cWidth > cHeight ? cHeight * 0.8 : cWidth * 0.8);
  }
  return { height: tempH + "px", width: tempW + "px" }
}

/*
* 格式化金額
* 參數說明：
* number：要格式化的數字
* decimals：保留幾位小數
* dec_point：小數點符號
* thousands_sep：千分位符號
* */
export function number_format1(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/*
* 直接捨去
* 參數說明：
* number：要格式化的數字
* decimals：保留幾位小數
* dec_point：小數點符號
* thousands_sep：千分位符號
* */
export function number_format2(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,

    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.floor(n * k) / k;
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  console.log(s)
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

export function htmlReg (msg) {
  var msg = msg.replace(/<[^>]+>|&[^>]+;/g, ''); //去除HTML Tag
  // msg = msg.replace(/[|]*\n/, '') //去除行尾空格
  // msg = msg.replace(/&npsp;/ig, ''); //去掉npsp
  return msg;
}
